import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const OffExchangeIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M2.40625 14.9788H14.5938M2.40625 5.49959V6.17668C2.40625 6.7154 2.62026 7.23205 3.00119 7.61299C3.38212 7.99392 3.89878 8.20793 4.4375 8.20793C4.97622 8.20793 5.49288 7.99392 5.87381 7.61299C6.25474 7.23205 6.46875 6.7154 6.46875 6.17668M2.40625 5.49959H14.5938M2.40625 5.49959L3.76042 2.79126H13.2396L14.5938 5.49959M6.46875 6.17668V5.49959M6.46875 6.17668C6.46875 6.7154 6.68276 7.23205 7.06369 7.61299C7.44462 7.99392 7.96128 8.20793 8.5 8.20793C9.03872 8.20793 9.55538 7.99392 9.93631 7.61299C10.3172 7.23205 10.5312 6.7154 10.5312 6.17668M10.5312 6.17668V5.49959M10.5312 6.17668C10.5312 6.7154 10.7453 7.23205 11.1262 7.61299C11.5071 7.99392 12.0238 8.20793 12.5625 8.20793C13.1012 8.20793 13.6179 7.99392 13.9988 7.61299C14.3797 7.23205 14.5937 6.7154 14.5938 6.17668V5.49959M3.76042 14.9788V8.10643M13.2396 14.9788V8.10643M6.46875 14.9788V12.2704C6.46875 11.9113 6.61142 11.5668 6.86538 11.3129C7.11933 11.0589 7.46377 10.9163 7.82292 10.9163H9.17708C9.53623 10.9163 9.88067 11.0589 10.1346 11.3129C10.3886 11.5668 10.5312 11.9113 10.5312 12.2704V14.9788"
          stroke="#1A1721"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.625 2.79126L13.375 14.5725"
          stroke="#1A1721"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
